export function concatenarArraySi(valores, separador, contiene) {
  const lista = Array.isArray(valores) ? valores : [valores]
  const sep = separador == null ? '' : String(separador)
  const filtro = contiene == null ? '' : String(contiene)

  return lista
    .filter((v) => v != null && v !== '')
    .map(String)
    .filter((v) => (filtro ? v.includes(filtro) : true))
    .join(sep)
}
